import { Routes } from '@angular/router';

import { provideJobCreationFlow } from '@guardfinder/shared';

export const routes: Routes = [
    {
        path: '',
        title: 'Welcome',
        loadComponent: () => import('../containers/welcome/welcome.component').then(m => m.WelcomeComponent)
    },
    {
        path: 'jobs/new',
        providers: [provideJobCreationFlow()],
        children: [
            {
                path: 'share-your-location',
                title: 'Share your location',
                loadComponent: () =>
                    import('../containers/jobs/create/leads/lead/lead.component').then(m => m.LeadComponent)
            },
            {
                path: 'date-time',
                title: 'Set a date and time',
                loadComponent: () =>
                    import('../containers/jobs/create/date-time/date-time.component').then(m => m.DateTimeComponent)
            },
            {
                path: 'contact-info',
                title: 'Primary contact person',
                loadComponent: () =>
                    import('../containers/jobs/create/contact-info/contact-info.component').then(
                        m => m.ContactInfoComponent
                    )
            },
            {
                path: 'info',
                title: 'Tell us about your job',
                loadComponent: () =>
                    import('../containers/jobs/create/job-info/job-info.component').then(m => m.JobInfoComponent)
            },
            {
                path: 'review',
                title: 'Review your new job',
                loadComponent: () =>
                    import('../containers/jobs/create/review/review.component').then(m => m.ReviewComponent)
            },
            {
                path: 'success',
                title: 'Successfully published job',
                loadComponent: () =>
                    import('../containers/jobs/create/success/success.component').then(m => m.SuccessComponent)
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'date-time'
            }
        ]
    },
    {
        path: 'welcome',
        pathMatch: 'full',
        redirectTo: ''
    },
    { path: '**', redirectTo: '' }
];
